import actions from "./actions";

const initState = {
    loading: false,
    getApiKeyError: null,
    apiKeyError: null,
    apiKeyMessage: null,
    buttonLoading: false,
    apiKeyResult: [],
    apiKeyFormModal: false,

};

export default function reducer(state = initState, action) {
    switch (action.type) {

        case actions.GET_API_KEY_BY_DEALER_ID:
            return {
                ...state,
                loading: true,
                getApiKeyError: null,
                apiKeyMessage: null,
                apiKeyResult: [],
            };
        case actions.GET_API_KEY_BY_DEALER_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                getApiKeyError: null,
                apiKeyMessage: null,
                apiKeyResult: action.result,
            };
        case actions.GET_API_KEY_BY_DEALER_ID_FAILED:
            return {
                ...state,
                loading: false,
                getApiKeyError: action.error,
                apiKeyMessage: null,
            };

        case actions.OPEN_API_KEY_MODAL:
            return {
                ...state,
                apiKeyFormModal: true
            };
        case actions.CLOSE_API_KEY_MODAL:
            return {
                ...state,
                apiKeyFormModal: false
            };


        case actions.ADD_UPDATE_API_KEY:
            return {
                ...state,
                apiKeyError: null,
                apiKeyMessage: null,
                buttonLoading: true
            };
        case actions.ADD_UPDATE_API_KEY_SUCCESS:
            return {
                ...state,
                apiKeyMessage: action.message,
                apiKeyResult: action.result,
                buttonLoading: false,
                apiKeyError: null,
                apiKeyFormModal: false
            };
        case actions.ADD_UPDATE_API_KEY_FAILED:
            return {
                ...state,
                apiKeyError: action.error,
                apiKeyMessage: null,
                buttonLoading: false,
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                apiKeyError: null,
                apiKeyMessage: null,
                getApiKeyError: null,
            };

        case actions.RESET_SEARCH_DATA:
            return {
                ...state,
                apiKeyResult: [],
            };

        default:
            return state;
    }
}